exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pagination{border-color:#e9e9e9;margin-top:0;margin-bottom:5px;height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-120e1188!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Grid.vue
// module id = 847
// module chunks = 2